<template lang="pug">
.marble-rafting-group
  .eracing-mainmarket-item.collapsed(
    v-if="source.items != null && source.items[0] != null && source.items.length == 6"
    type='button' 
    :id="source.items[0].id"
    data-toggle='collapse' 
    :data-target="'#mainmarket-' + source.items[0].matchId"
  )
    efTimer(:source="source.items[0]" :horiz="true" :class="{ 'd-none' : source.items[0].marketId == 3 }")
    .live-icon-wrapper(:class="{ 'd-none' : source.items[0].marketId != 3 }")
      img.live-icon(src='images/egame/live-icon.svg')
      span.mx-1 LIVE
      .live-dot
  .collapse.show(
    :id="'mainmarket-' + source.items[0].matchId"
  )
    .match-collapse-body
      //- small {{ source.items[0].details['ml'][0] }}
      .marble-market-group
        .winners-market.flex-wrap
          .d-flex.align-items-center.justify-content-center.mt-2.mb-2.player-info-wrapper
            img.characters(src='images/egame/crown/no1.svg')
            .ml-2.player-name-wrapper
              | {{ $t("ui.no1") }}
          .odds-group-wrapper
            .odds-group
              .bettype-col {{ $t("m.GR_RED") }} (1)
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[5] && source.items[5].details['cs'] && source.items[5].details['cs'][0] && source.items[5].details['cs'][0][5] != 0 && source.items[5].details['cs'][0][5] != ''")
                  OddsItem(:odds="source.items[5].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled
            .odds-group
              .bettype-col {{ $t("m.GR_YELLOW") }} (2)
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[5] && source.items[5].details['cs'] && source.items[5].details['cs'][1] && source.items[5].details['cs'][1][5] != 0 && source.items[5].details['cs'][1][5] != ''")
                  OddsItem(:odds="source.items[5].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled
            .odds-group
              .bettype-col {{ $t("m.GR_BLUE") }} (3)
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[5] && source.items[5].details['cs'] && source.items[5].details['cs'][2] && source.items[5].details['cs'][2][5] != 0 && source.items[5].details['cs'][2][5] != ''")
                  OddsItem(:odds="source.items[5].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled
            .odds-group
              .bettype-col {{ $t("m.GR_GREEN") }} (4)
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[5] && source.items[5].details['cs'] && source.items[5].details['cs'][3] && source.items[5].details['cs'][3][5] != 0 && source.items[5].details['cs'][3][5] != ''")
                  OddsItem(:odds="source.items[5].details['cs'][3]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled
          .odds-group-wrapper
            .odds-group
              .bettype-col {{ $t("m.GR_OVER") }}
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[5] && source.items[5].details['ou'] && source.items[5].details['ou'][0] && source.items[5].details['ou'][0][12] != 0 && source.items[5].details['ou'][0][12] != ''")
                  OddsItem(:odds="source.items[5].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[5].details" homeAway="1")
                template(v-else)
                  OddsDisabled
            .odds-group
              .bettype-col {{ $t("m.GR_UNDER") }}
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[5] && source.items[5].details['ou'] && source.items[5].details['ou'][0] && source.items[5].details['ou'][0][11] != 0 && source.items[5].details['ou'][0][11] != ''")
                  OddsItem(:odds="source.items[5].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[5].details" homeAway="2")
                template(v-else)
                  OddsDisabled
            .odds-group
              .bettype-col {{ $t("m.GR_ODD") }}
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[5] && source.items[5].details['oe'] && source.items[5].details['oe'][0] && source.items[5].details['oe'][0][5] != 0 && source.items[5].details['oe'][0][5] != ''")
                  OddsItem(:odds="source.items[5].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
                template(v-else)
                  OddsDisabled
            .odds-group
              .bettype-col {{ $t("m.GR_EVEN") }}
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[5] && source.items[5].details['oe'] && source.items[5].details['oe'][0] && source.items[5].details['oe'][0][7] != 0 && source.items[5].details['oe'][0][7] != ''")
                  OddsItem(:odds="source.items[5].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
                template(v-else)
                  OddsDisabled
        .normal-market.pb-0
          .bettype {{ $t("ui.best_3_balls") }}
          .odds-group-wrapper
            .odds-group
              .bettype-col {{ $t("m.GR_SINGLE") }}
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[4] && source.items[4].details['oxt'] && source.items[4].details['oxt'][0]")
                  OddsItem(:odds="source.items[4].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
            .odds-group
              .bettype-col {{ $t("m.GR_PAIR") }}
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[4] && source.items[4].details['oxt'] && source.items[4].details['oxt'][0]")
                  OddsItem(:odds="source.items[4].details['oxt'][0]" idx=6 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
            .odds-group
              .bettype-col {{ $t("m.GR_TRIPS") }}
              template(v-if="source.items[0].marketId == 3")
                OddsDisabled
              template(v-else)
                template(v-if="source.items[4] && source.items[4].details['oxt'] && source.items[4].details['oxt'][0]")
                  OddsItem(:odds="source.items[4].details['oxt'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
        .normal-market.d-flex
          .flex-grow-1
            .red-team
              img(src='images/egame/marble-rafting-characters/red.svg')
              span {{ $t("ui.red") }}
            .odds-group-wrapper
              .odds-group
                .bettype-col {{ $t("m.GR_ADVANCED") }}
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[0] && source.items[0].details['ml'] && source.items[0].details['ml'][0]")
                    OddsItem(:odds="source.items[0].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col {{ $t("m.GR_ELIMINATED") }}
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[0] && source.items[0].details['ml'] && source.items[0].details['ml'][0]")
                    OddsItem(:odds="source.items[0].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
            .odds-group-wrapper
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_HIT1") }} 
                  br
                  | (1)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][0] && source.items[0].details['cs'][0][5] != 0 && source.items[0].details['cs'][0][5] != ''")
                    OddsItem(:odds="source.items[0].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_HIT2") }} 
                  br
                  | (2)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][1] && source.items[0].details['cs'][1][5] != 0 && source.items[0].details['cs'][1][5] != ''")
                    OddsItem(:odds="source.items[0].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_PERFECT") }} 
                  br
                  | (3)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][2] && source.items[0].details['cs'][2][5] != 0 && source.items[0].details['cs'][2][5] != ''")
                    OddsItem(:odds="source.items[0].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
          .flex-grow-1
            .yellow-team
              img(src='images/egame/marble-rafting-characters/yellow.svg')
              span {{ $t("ui.yellow") }}
            .odds-group-wrapper
              .odds-group
                .bettype-col {{ $t("m.GR_ADVANCED") }}
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0]")
                    OddsItem(:odds="source.items[1].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col {{ $t("m.GR_ELIMINATED") }}
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0]")
                    OddsItem(:odds="source.items[1].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
            .odds-group-wrapper
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_HIT1") }} 
                  br
                  | (1)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[1] && source.items[1].details['cs'] && source.items[1].details['cs'][0] && source.items[1].details['cs'][0][5] != 0 && source.items[1].details['cs'][0][5] != ''")
                    OddsItem(:odds="source.items[1].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_HIT2") }} 
                  br
                  | (2)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[1] && source.items[1].details['cs'] && source.items[1].details['cs'][1] && source.items[1].details['cs'][1][5] != 0 && source.items[1].details['cs'][1][5] != ''")
                    OddsItem(:odds="source.items[1].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_PERFECT") }} 
                  br
                  | (3)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[1] && source.items[1].details['cs'] && source.items[1].details['cs'][2] && source.items[1].details['cs'][2][5] != 0 && source.items[1].details['cs'][2][5] != ''")
                    OddsItem(:odds="source.items[1].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
        .normal-market.d-flex
          .flex-grow-1
            .blue-team
              img(src='images/egame/marble-rafting-characters/blue.svg')
              span {{ $t("ui.blue") }}
            .odds-group-wrapper
              .odds-group
                .bettype-col {{ $t("m.GR_ADVANCED") }}
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0]")
                    OddsItem(:odds="source.items[2].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col {{ $t("m.GR_ELIMINATED") }}
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0]")
                    OddsItem(:odds="source.items[2].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
            .odds-group-wrapper
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_HIT1") }} 
                  br
                  | (1)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[0] && source.items[2].details['cs'] && source.items[2].details['cs'][0] && source.items[2].details['cs'][0][5] != 0 && source.items[2].details['cs'][0][5] != ''")
                    OddsItem(:odds="source.items[2].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_HIT2") }} 
                  br
                  | (2)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[2] && source.items[2].details['cs'] && source.items[2].details['cs'][1] && source.items[2].details['cs'][1][5] != 0 && source.items[2].details['cs'][1][5] != ''")
                    OddsItem(:odds="source.items[2].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_PERFECT") }} 
                  br
                  | (3)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[2] && source.items[2].details['cs'] && source.items[2].details['cs'][2] && source.items[2].details['cs'][2][5] != 0 && source.items[2].details['cs'][2][5] != ''")
                    OddsItem(:odds="source.items[2].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
          .flex-grow-1
            .green-team
              img(src='images/egame/marble-rafting-characters/green.svg')
              span {{ $t("ui.green") }}
            .odds-group-wrapper
              .odds-group
                .bettype-col {{ $t("m.GR_ADVANCED") }}
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0]")
                    OddsItem(:odds="source.items[3].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col {{ $t("m.GR_ELIMINATED") }}
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0]")
                    OddsItem(:odds="source.items[3].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
            .odds-group-wrapper
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_HIT1") }} 
                  br
                  | (1)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][0] && source.items[3].details['cs'][0][5] != 0 && source.items[3].details['cs'][0][5] != ''")
                    OddsItem(:odds="source.items[3].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_HIT2") }} 
                  br
                  | (2)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][1] && source.items[3].details['cs'][1][5] != 0 && source.items[3].details['cs'][1][5] != ''")
                    OddsItem(:odds="source.items[3].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .odds-group
                .bettype-col 
                  | {{ $t("m.GR_PERFECT") }} 
                  br
                  | (3)
                template(v-if="source.items[0].marketId == 3")
                  OddsDisabled
                template(v-else)
                  template(v-if="source.items[3] && source.items[3].details['cs'] && source.items[3].details['cs'][2] && source.items[3].details['cs'][2][5] != 0 && source.items[3].details['cs'][2][5] != ''")
                    OddsItem(:odds="source.items[3].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled

</template>

<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: { 
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    },
    racingList(){
      return config.racingList;
    }
   },
  methods: {
    team(player, pos, isTeam) {
      if(isTeam) {
        var n = player.homeTeam;
        return n;
      } else {
        var n = player.homeTeam.split(" - ")[pos];
        return n;
      }
    },
    getImage(x) {
      return "images/egame/marble-survival/ball" + String(this.team(x, 0)) +".svg";
    }
  }
};
</script>